// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3XEpv","top":"styles_top__1dO-x"};